// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2795a695","101":"0cb5a5bc","441":"932779a8","526":"fe954474","741":"9390cef3","814":"e1ce6e01"}[chunkId] + ".chunk.js";
};